import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ChargesService {

  constructor(private http:HttpClient) { }

  addPlatformAndConvenienceFee(data) {
    return this.http.post(`${environment.apiUrl}platformconviencefee`,data);
  }

  updatePlatformAndConvenienceFee(id,data) {
    return this.http.put(`${environment.apiUrl}platformconviencefee/${id}`,data);
  }

  getPlatformAndConvenienceFeesById(id:string) {
    return this.http.get(`${environment.apiUrl}platformconviencefee/${id}`);
  }

  getPlatformAndConvenienceFees() {
    return this.http.get(`${environment.apiUrl}platformconviencefee`);
  }

}
